import type { MaybeRefOrGetter, Ref } from 'vue';

import { computed, toValue } from 'vue';

import type { ChartGeometry } from './chart-geometry';

import { buildIndexScale, buildValueScale, buildValueTicks } from './chart-scales';

export function useBarChartScale(
  values: () => readonly number[],
  count: MaybeRefOrGetter<number>,
  geometry: Ref<ChartGeometry>,
) {
  const valueScale = computed(() => buildValueScale(values(), [geometry.value.plotBottom, geometry.value.plotTop]));
  const valueTicks = computed(() => buildValueTicks(valueScale.value));
  const pointSlotWidth = computed(() => geometry.value.plotWidth / Math.max(1, toValue(count)));
  const centerScale = computed(() =>
    buildIndexScale(toValue(count), [
      geometry.value.plotLeft + pointSlotWidth.value / 2,
      geometry.value.plotRight - pointSlotWidth.value / 2,
    ]),
  );
  const barHeight = (value: number): number =>
    value <= 0 ? 0 : Math.max(1, geometry.value.plotBottom - valueScale.value(value));

  return { valueScale, valueTicks, pointSlotWidth, centerScale, barHeight };
}
